import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { Customer, CustomerList, Inspection, ListFilters, ListResults, Policy } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(protected http: HttpClient) {}

  public list(filters?: ListFilters) {
    return this.http.get<ListResults<CustomerList>>(`${env.APIUrl}/customer`, { params: filters as any });
  }

  public get(id: number) {
    return this.http.get<Customer>(`${env.APIUrl}/customer/${id}`).toPromise();
  }

  public archived(filters?: ListFilters) {
    return this.http
      .get<ListResults<CustomerList>>(`${env.APIUrl}/customer/archived`, { params: filters as any })
      .toPromise();
  }

  public archive(id: number) {
    return this.http.put<Customer>(`${env.APIUrl}/customer/${id}/archive`, null).toPromise();
  }

  public restore(id: number) {
    return this.http.put<Customer>(`${env.APIUrl}/customer/${id}/restore`, null).toPromise();
  }

  public remove(id: number) {
    return this.http.delete<Customer>(`${env.APIUrl}/customer/${id}`).toPromise();
  }

  public edit(id: number, customer: Customer) {
    return this.http.put<Customer>(`${env.APIUrl}/customer/${id}`, customer).toPromise();
  }

  public create(customer: Customer) {
    return this.http.post<Customer>(`${env.APIUrl}/customer`, customer).toPromise();
  }

  public policies(customerId: number) {
    return this.http.get<Policy[]>(`${env.APIUrl}/customer/${customerId}/policies`);
  }

  public inspections(customerId: number) {
    return this.http.get<Inspection[]>(`${env.APIUrl}/customer/${customerId}/inspections`);
  }

  public count() {
    return this.http.get<{ active: boolean; count: number }[]>(`${env.APIUrl}/customer/count`).toPromise();
  }
}
